import { useRef } from 'react'
import { GuildAccessNotch } from '@/molecules/GuildAccessNotch'
import { Thumbnail } from '@/molecules/Thumbnail'
import { useGuildMember } from '@/services/GuildUserService'
import { LinkViewProps } from '@/services/RenderService'
import { formatCloudinaryPath } from '@/utils/Cloudinary/cloudinary'

export function LandscapeLink(props: LinkViewProps) {
  const cardRef = useRef<HTMLDivElement>(null)
  const { isGuildMember, loading } = useGuildMember()

  return (
    <div
      className="relative my-2 overflow-hidden rounded-lg duration-[400ms] ease-in-out hover:z-10 md:hover:scale-[1.05]"
      ref={cardRef}
    >
      <Thumbnail
        showTitle={false}
        className="mr-4"
        href={props.link.linkUrl}
        cloudinaryImagePath={formatCloudinaryPath(props.link.imageUrl) as string}
        title={props.link.alt}
        includePlayCircle={false}
      />
      <GuildAccessNotch isInEarlyAccess={props.link.isInEarlyAccess} isGuildMember={isGuildMember} loading={loading} />
    </div>
  )
}
